// Custom scroll indicator functionality for desktop product grid
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth >= 768) {
    const gridContainer = document.getElementById('productGrid');
    const scrollThumb = document.getElementById('scrollThumb');
    const scrollUpBtn = document.querySelector('.scroll-up');
    const scrollDownBtn = document.querySelector('.scroll-down');

    if (gridContainer && scrollThumb && scrollUpBtn && scrollDownBtn) {
      function updateScrollThumb() {
        const scrollTop = gridContainer.scrollTop;
        const scrollHeight = gridContainer.scrollHeight;
        const clientHeight = gridContainer.clientHeight;
        
        // Track height is 88px (120px - 32px for 16px margins)
        const trackHeight = 88;
        
        // Calculate thumb height as percentage of visible area
        const thumbHeight = Math.max(20, (clientHeight / scrollHeight) * trackHeight);
        
        // Calculate thumb position within the track (respects 16px margins)
        const scrollPercentage = scrollTop / (scrollHeight - clientHeight);
        const maxThumbTop = trackHeight - thumbHeight;
        const thumbTop = scrollPercentage * maxThumbTop;
        
        scrollThumb.style.height = thumbHeight + 'px';
        scrollThumb.style.transform = `translateY(${thumbTop}px)`;
      }

      function scrollToPosition(direction) {
        // const scrollAmount = gridContainer.clientHeight * 0.8; // Scroll 80% of visible height
        const scrollAmount = 150;
        const currentScroll = gridContainer.scrollTop;
        const newScroll = direction === 'up' 
          ? Math.max(0, currentScroll - scrollAmount)
          : Math.min(gridContainer.scrollHeight - gridContainer.clientHeight, currentScroll + scrollAmount);

        gridContainer.scrollTo({
          top: newScroll,
          behavior: 'smooth'
        });
      }

      // Update thumb on scroll
      gridContainer.addEventListener('scroll', updateScrollThumb);

      // Handle button clicks
      scrollUpBtn.addEventListener('click', () => scrollToPosition('up'));
      scrollDownBtn.addEventListener('click', () => scrollToPosition('down'));

      // Initial thumb position
      updateScrollThumb();

      // Handle window resize
      window.addEventListener('resize', () => {
        if (window.innerWidth >= 768) {
          updateScrollThumb();
        }
      });
    }
  }
});